export const createKeyPressHandler = keymap => e => {
  if (keymap.hasOwnProperty(e.key)) {
    keymap[e.key](e);
  }
};
